module.exports = __webpack_public_path__ + "static/media/open-veins-eduardo-galeano.e5dd51a4.jpg";